import * as actions from '../../actions/reports/outBoundReportsActions'

export const initialState = {
    startDate:new Date(),
    endDate : new Date()
}

export default function inventoryReducer(state = initialState, action) {
    switch (action.type) {
        case actions.STORE_START_END_DATE:
            return { ...state, startDate: action.startDate, endDate: action.endDate }
        default:
            return state
    }
}